function areLocationsEqual (location1, location2) {
    if (arguments.length < 2) {
        throw new Error('Invalid Argument: Function expects two location arguments.')
    }
    if (location1 === location2) {
        return true
    }
    return (
        Boolean(location1) &&
        Boolean(location2) &&
        (location1.latitude || NaN) === (location2.latitude || NaN) &&
        (location1.longitude || NaN) === (location2.longitude || NaN)
    )
}

export default {
    areLocationsEqual
}
